import axios, { AxiosInstance } from 'axios';
import { authService } from './AuthService';

const createAxiosService = () => {
  let publicInstance: AxiosInstance;
  let securedInstance: AxiosInstance;
  let authenticationToken: string;

  const baseURL = process.env.REACT_APP_API_ENDPOINT;

  const getPublicInstance = () => {
    if (!publicInstance) {
      publicInstance = axios.create({
        baseURL,
        headers: {
          Accept: 'application/json',
        },
      });
    }

    return publicInstance;
  };

  const getSecuredInstance = (token?: string) => {
    // If token is provided directly, use it (for cases where cookies might not be available yet)
    // Otherwise, read from cookies
    let currentAuthenticationToken: string;

    if (token) {
      currentAuthenticationToken = token;
    } else {
      const authData = authService.getAuthenticationData();

      if (!authData || !authData.authenticationToken) {
        throw new Error('Authentication token not found. Please login again.');
      }

      currentAuthenticationToken = authData.authenticationToken;
    }

    if (
      currentAuthenticationToken !== authenticationToken ||
      !securedInstance ||
      token // If token is provided directly, always create new instance
    ) {
      securedInstance = axios.create({
        baseURL,
        headers: {
          Authorization: `Bearer ${currentAuthenticationToken}`,
          Accept: 'application/json',
        },
      });

      authenticationToken = currentAuthenticationToken;
    }

    return securedInstance;
  };

  return Object.freeze({
    getPublicInstance,
    getSecuredInstance,
  });
};

export const axiosService = createAxiosService();
